function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34",
  height: "24",
  viewBox: "0 0 34 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  y: ".5",
  width: "33",
  height: "23",
  rx: "3.5",
  fill: "#fff",
  stroke: "#D9D9D9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.75 15.858H8.69L7.147 9.792c-.073-.279-.229-.525-.458-.642A6.573 6.573 0 004.8 8.508v-.233h3.318c.458 0 .801.35.859.758l.801 4.376 2.059-5.134h2.002l-3.089 7.583zm4.234 0H13.04l1.602-7.583h1.945l-1.602 7.583zm4.119-5.482c.057-.409.4-.642.801-.642a3.535 3.535 0 011.888.35l.344-1.633a4.801 4.801 0 00-1.774-.351c-1.888 0-3.262 1.05-3.262 2.508 0 1.11.973 1.692 1.66 2.042.743.35 1.03.584.972.934 0 .524-.572.758-1.143.758a4.789 4.789 0 01-2.003-.467l-.343 1.633c.687.292 1.43.409 2.117.409 2.117.058 3.432-.992 3.432-2.567 0-1.983-2.69-2.1-2.69-2.974zm9.497 5.482l-1.545-7.583h-1.659a.862.862 0 00-.801.583l-2.86 7h2.002l.4-1.108h2.46l.23 1.108H28.6zm-2.917-5.54l.571 2.857h-1.602l1.03-2.858z",
  fill: "#172B85"
})));